export const CANVAS_WIDTH = 1200;
export const CANVAS_HEIGHT = 600;

export const RIGHT = 'Right';
export const LEFT = 'Left';
export const UP = 'Up';
export const DOWN = 'Down';

// Initial snake coordinates where the snake will start it's position from in the canvas
export const SNAKE = [
  {
    x: 400,
    y: 200,
  },
  {
    x: 380,
    y: 200,
  },
  {
    x: 360,
    y: 200,
  },
  {
    x: 340,
    y: 200,
  },
  {
    x: 320,
    y: 200,
  },
];
